import { MenuData } from "../types/menu";
import { PATHS } from "../routes/paths";
import {
  PeopleAltOutlined,
  FactoryOutlined,
  BusinessOutlined,
  AcUnitOutlined,
  RestaurantOutlined,
  NoteAddOutlined,
  DescriptionOutlined,
  LayersOutlined,
  PersonOutlined,
  CleaningServices,
  CategoryOutlined,
} from "@mui/icons-material";

export const getMenu = async (role: string): Promise<MenuData> => {
  // if (role === "admin") {
  return {
    data: [
      {
        group_id: "1",
        group_name: "報告書",
        menu: [
          {
            number: 1,
            title: "エアコン報告書",
            url: PATHS.REPORT_AIRCON_LIST,
            icon: AcUnitOutlined,
            popup: false,
          },
          {
            number: 2,
            title: "フード報告書",
            url: PATHS.REPORT_FOOD_LIST,
            icon: RestaurantOutlined,
            popup: false,
          },
          {
            number: 3,
            title: "床報告書",
            url: PATHS.REPORT_FLOOR_LIST,
            icon: LayersOutlined,
            popup: false,
          },
          {
            number: 4,
            title: "フリー報告書",
            url: PATHS.REPORT_FREE_LIST,
            icon: DescriptionOutlined,
            popup: false,
          },
        ],
      },
      {
        group_id: "2",
        group_name: "受注書",
        menu: [
          {
            number: 1,
            title: "受注書",
            url: PATHS.ORDER_LIST,
            icon: NoteAddOutlined,
            popup: false,
          },
        ],
      },
      {
        group_id: "3",
        group_name: "マスタ",
        menu: [
          {
            number: 1,
            title: "営業担当者",
            url: PATHS.SALES_PERSON_LIST,
            icon: PersonOutlined,
            popup: false,
          },
          {
            number: 2,
            title: "作業名称",
            url: PATHS.WORK_TYPE_LIST,
            icon: CleaningServices,
            popup: false,
          },
          {
            number: 3,
            title: "製造メーカー",
            url: PATHS.MANUFACTURER_LIST,
            icon: FactoryOutlined,
            popup: false,
          },
          {
            number: 4,
            title: "アカウント管理",
            url: PATHS.ACCOUNT_LIST,
            icon: PeopleAltOutlined,
            popup: false,
          },
        ],
      },
    ],
  };
  // } else {
  //   return {
  //     data: [
  //       {
  //         group_id: "1",
  //         group_name: "コール",
  //         menu: [
  //           {
  //             number: 1,
  //             title: "探索",
  //             url: PATHS.EXPLORE_TOP,
  //             // icon: "<ReceiptOutlinedIcon />",
  //             // icon: () =>  HomeOutlined,
  //             // icon : JSX.Element,
  //             // icon: <HomeOutlined />,
  //             icon: HomeOutlined,
  //             popup: false,
  //           },
  //           {
  //             number: 4,
  //             title: "アップロード",
  //             url: PATHS.MY_POST_LIST,
  //             icon: SettingsOutlined,
  //             popup: false,
  //           },
  //           {
  //             number: 5,
  //             title: "通知",
  //             url: PATHS.MYPAGE_NOTIFICATION,
  //             icon: HomeOutlined,
  //             // icon: "<ManageAccountOutlinedIcon />",
  //             popup: false,
  //           },
  //           {
  //             number: 6,
  //             title: "アカウント",
  //             url: PATHS.MYPAGE,
  //             icon: HomeOutlined,

  //             // icon: "<LogoutOutlined />",
  //             popup: false,
  //           },
  //         ],
  //       },
  //     ],
  //   };
  // }
};
